import React from 'react';
import AppRoutes from './routes';
import { ToastProvider } from './components/Toast';

function App() {
  return (
    <ToastProvider>
      <AppRoutes />
    </ToastProvider>
  );
}

export default App;
